const DEFAULT_API_BASE = 'https://alakaialohaadventures-782c9.web.app';

function apiBase() {
  const fromEnv = process.env.REACT_APP_SITE_API_BASE;
  if (fromEnv && typeof fromEnv === 'string') {
    return fromEnv.replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin?.includes('alakaialoha')) {
    return window.location.origin;
  }

  return DEFAULT_API_BASE;
}

async function fetchJson(url, label) {
  const res = await fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
    },
  });

  const raw = await res.text();
  if (!res.ok) {
    throw new Error(`${label} failed (${res.status}): ${raw.slice(0, 240)}`);
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    throw new Error(`${label} returned invalid JSON`);
  }
}

export async function getBeachConditionsIndex(options = {}) {
  const params = new URLSearchParams();
  if (typeof options.island === 'string' && options.island) params.set('island', options.island);
  if (typeof options.mode === 'string' && options.mode) params.set('mode', options.mode);
  if (typeof options.region === 'string' && options.region) params.set('region', options.region);
  if (typeof options.activity === 'string' && options.activity) params.set('activity', options.activity);
  if (Number.isFinite(options.limit)) params.set('limit', String(options.limit));
  const query = params.toString();
  const url = `${apiBase()}/api/beach-conditions${query ? `?${query}` : ''}`;
  return fetchJson(url, 'Beach conditions index');
}

export async function getBeachConditionsDetail(slug, options = {}) {
  if (!slug) throw new Error('Missing beach slug');
  const params = new URLSearchParams();
  if (typeof options.island === 'string' && options.island) params.set('island', options.island);
  const query = params.toString();
  const url = `${apiBase()}/api/beach-conditions/${encodeURIComponent(slug)}${query ? `?${query}` : ''}`;
  return fetchJson(url, 'Beach conditions detail');
}
